import { HttpStatusCode } from "axios";
import ITeamMember from "../models/ITeamMember";
import networkService from "./NetworkService";

class TeamMemberService {

    /**
     * @description Gets all team members
     */
    async getTeamMembers(): Promise<ITeamMember[]> {
        const result = await networkService.get<ITeamMember[]>(`/team-members`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status !== HttpStatusCode.NoContent
            ? result.data as ITeamMember[]
            : [];
    }
    
    /**
     * @description Gets a team member's photo URL
     * @param {string} id - The UUID of the team member
     */
    getTeamMemberPhotoUrl = (id: string): string => {
        let baseUrl = process.env.REACT_APP_API_BASE_URL || "/api/";
        const endpoint = `/team-member/${id}/photo`;
        
        if (baseUrl?.endsWith("/")) {
            baseUrl = baseUrl.slice(0, -1);
        }

        return `${baseUrl}${endpoint}`;
    };
}

const teamMemberService = new TeamMemberService();
export default teamMemberService;